<div class="db-security" [ngClass]="{'empty-page': securityPlugin && (!securityPlugin.paidVersionInstalled || !securityPlugin.active)}">
  <ds-mobile-page-title></ds-mobile-page-title>
  <div class="db-security__content" [ngClass]="{'db-page-with-banner': hasHostingBanner}" *ngIf="securityPlugin && securityPlugin.paidVersionInstalled && securityPlugin.active">
    <div class="db-security__main-content">
      <db-tabs [activeTabId]="activeTab.value" (onActiveTabChange)="onActiveTabChange($event)">
        <db-tab-head tabId="issues"><span class="sl-issues-tab">Issues</span></db-tab-head>
        <db-tab-head tabId="ignoredIssues"><span class="sl-ignored-issues-tab">Ignored Issues</span></db-tab-head>
        <!--<db-tab-head tabId="vulnerabilities"><span class="sl-vulnerabilities-tab">Vulnerabilities</span></db-tab-head>-->
        <db-tab-head tabId="settings"><span class="sl-settings-tab">Settings</span></db-tab-head>
        <db-tab-head tabId="scheduling"><span class="sl-scheduling-tab">Scheduling</span></db-tab-head>

        <db-tab-content tabId="issues">
          <ng-container *ngIf="activeTab.value === 'issues'">
            <div class="db-security__issues db-security__panel db-panel db-panel_flex db-panel_full-height" *ngIf="(securityIssues$ | async) && (securityIssues$ | async).length">
              <div class="db-panel__header">
                <div class="db-security__panel-row db-security__panel-row_header">
                  <div>
                    <div class="file-path">File</div>
                    <div class="file-issue">Issue</div>
                    <div class="file-action">Ignore</div>
                  </div>
                </div>
              </div>

              <div class="db-panel__body" dbCustomScrollbar>
                <db-issue-item [activeTab]="activeTab.value" (restoreFile)="restoreFile(securityIssue)" [issueIds]="restoringIssueIds" (doAction)="ignoreIssue(securityIssue)" (toggled)="onItemToggled($event)" *ngFor="let securityIssue of (securityIssues$ | async); trackBy: issueTrackBy;" class="db-product-item-host_view_list" [website]="website" [securityIssue]="securityIssue"></db-issue-item>
              </div>
              <div class="db-security_issues_footer__actions db-panel__footer">
                <label>
                  <span class="db-fc-checkbox"><input type="checkbox" [formControl]="selectAll" (change)="toggleAllItemsSelected($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
                  <span class="db-security_issues_footer__actions-label">{{'text_selectAll' | dbText}}</span>
                </label>

                <div>
                  <span class="db-security_issues_footer__actions-label" *ngIf="selectedIssues && !!selectedIssues.length">{{'text_selectedIssuesCount' | dbText : {selectedIssuesCount: selectedIssues.length} }}</span>
                  <a class="db-button db-button_info" (click)="bulkIgnore()" [ngClass]="{'db-button_disabled': !selectedIssues || !selectedIssues.length}"><span *ngIf="!bulkIgnoreLoading">Ignore</span>
                    <db-loading-circular-spinner class="sl-save-scheduling-params-progress" *ngIf="bulkIgnoreLoading"></db-loading-circular-spinner>
                  </a>
                </div>
              </div>
            </div>

            <div class="db-security__issues db-security__panel db-security__panel_empty db-panel db-panel_flex db-panel_full-height" *ngIf="!(securityIssues$ | async) || !(securityIssues$ | async).length">
              <div class="db-panel__body">
                <div class="db-security__panel-empty-message">There are no security issues.</div>
              </div>
            </div>
          </ng-container>
        </db-tab-content>

        <db-tab-content tabId="ignoredIssues">
          <ng-container *ngIf="activeTab.value === 'ignoredIssues'">
            <div class="db-security__ignored-issues db-security__panel db-panel db-panel_flex db-panel_full-height" *ngIf="(securityIgnoredIssues$ | async) && (securityIgnoredIssues$ | async).length">
              <div class="db-panel__header">
                <div class="db-security__panel-row db-security__panel-row_header">
                  <div>
                    <div class="file-path">File</div>
                    <div class="file-issue">Date</div>
                    <div class="file-action">Restore</div>
                  </div>
                </div>
              </div>

              <div class="db-panel__body" dbCustomScrollbar>
                <db-issue-item [activeTab]="activeTab.value" [issueIds]="restoringIssueIds" (doAction)="restoreIssue(securityIgnoredIssue)" (toggled)="onItemToggled($event)" *ngFor="let securityIgnoredIssue of (securityIgnoredIssues$ | async); trackBy: ignoredIssueTrackBy;" class="db-product-item-host_view_list" [website]="website" [securityIssue]="securityIgnoredIssue"></db-issue-item>
              </div>
              <div class="db-security_issues_footer__actions db-panel__footer">
                <label>
                  <span class="db-fc-checkbox"><input type="checkbox" [formControl]="selectAll" (change)="toggleAllItemsSelected($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
                  <span class="db-security_issues_footer__actions-label">{{'text_selectAll' | dbText}}</span>
                </label>

                <div>
                  <span class="db-security_issues_footer__actions-label" *ngIf="selectedIgnoredIssues && !!selectedIgnoredIssues.length">{{'text_selectedIssuesCount' | dbText : {selectedIssuesCount: selectedIgnoredIssues.length} }}</span>
                  <a class="db-button db-button_info" (click)="bulkRestore()" [ngClass]="{'db-button_disabled': !selectedIgnoredIssues || !selectedIgnoredIssues.length}"><span *ngIf="!bulkRestoreLoading">Restore</span>
                    <db-loading-circular-spinner class="sl-save-scheduling-params-progress" *ngIf="bulkRestoreLoading"></db-loading-circular-spinner>
                  </a>
                </div>
              </div>

            </div>

            <div class="db-security__ignored-issues db-security__panel db-security__panel_empty db-panel db-panel_flex db-panel_full-height" *ngIf="!(securityIgnoredIssues$ | async) || !(securityIgnoredIssues$ | async).length">
              <div class="db-panel__body">
                <div class="db-security__panel-empty-message">There are no ignored issues.</div>
              </div>
            </div>
          </ng-container>
        </db-tab-content>

        <!--<db-tab-content tabId="vulnerabilities">
          <ng-container *ngIf="activeTab.value === 'vulnerabilities'">
            <div class="db-security__vulnerabilities db-security__panel db-panel db-panel_flex db-panel_full-height" *ngIf="(securityVulnerabilities$ | async) && (securityVulnerabilities$ | async).length">
              <div class="db-panel__header">
                <div class="db-security__panel-row db-security__panel-row_header">
                  <div>
                    <div class="file-path">Title</div>
                    <div class="file-issue">References</div>
                    <div class="file-action">Type</div>
                  </div>
                </div>
              </div>

              <div class="db-panel__body" dbCustomScrollbar>
                <div class="db-security__panel-row sl-vulnerability-item" *ngFor="let securityVulnerability of (securityVulnerabilities$ | async)">
                  <div>
                    <div class="file-path">{{securityVulnerability.title}}</div>
                    <div>
                      <div *ngFor="let reference of securityVulnerability.references">
                        <a class="db-link" [href]="reference" target="_blank" rel="noopener">{{reference}}</a>
                      </div>
                    </div>
                    <div>{{securityVulnerability.type}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="db-security__vulnerabilities db-security__panel db-security__panel_empty db-panel db-panel_flex db-panel_full-height" *ngIf="!(securityVulnerabilities$ | async) || !(securityVulnerabilities$ | async).length">
              <div class="db-panel__body">
                <div class="db-security__panel-empty-message">There are no vulnerabilities.</div>
              </div>
            </div>
          </ng-container>
        </db-tab-content>-->

        <db-tab-content tabId="settings">
          <ng-container *ngIf="activeTab.value === 'settings'">
            <form [formGroup]="securitySettingsFg" class="db-security__settings db-security__panel db-panel db-panel_flex db-panel_full-height">
              <div class="db-panel__body">
                <!--<div class="db-security__panel-row">
                  <div>
                    <div class="file-path">Check for WordPress vulnerabilities:</div>
                    <div><span>No</span><db-fc-switch class="sl-setting-switch" [formControl]="wordpressVulnerabilitiesFc" color="success" [inverted]="true"></db-fc-switch><span>Yes</span></div>
                  </div>
                </div>

                <div class="db-security__panel-row">
                  <div>
                    <div class="file-path">Check for plugin vulnerabilities:</div>
                    <div><span>No</span><db-fc-switch class="sl-setting-switch" [formControl]="pluginsVulnerabilitiesFc" color="success" [inverted]="true"></db-fc-switch><span>Yes</span></div>
                  </div>
                </div>-->

                <div class="db-security__panel-row">
                  <div>
                    <div class="file-path">Compare core files with their repository versions to detect changes:</div>
                    <div><span>No</span><db-fc-switch class="sl-setting-switch" [formControl]="coreFilesChangesFc" color="success" [inverted]="true"></db-fc-switch><span>Yes</span></div>
                  </div>
                </div>

                <div class="db-security__panel-row">
                  <div>
                    <div class="file-path">Compare plugin files with their repository versions to detect changes:</div>
                    <div><span>No</span><db-fc-switch class="sl-setting-switch" [formControl]="pluginFilesChangesFc" color="success" [inverted]="true"></db-fc-switch><span>Yes</span></div>
                  </div>
                </div>

                <div class="db-security__panel-row">
                  <div>
                    <div class="file-path">Compare theme files with their repository versions to detect changes:</div>
                    <div><span>No</span><db-fc-switch class="sl-setting-switch" [formControl]="themeFilesChangesFc" color="success" [inverted]="true"></db-fc-switch><span>Yes</span></div>
                  </div>
                </div>
                <div class="db-security__panel-row">
                  <div>
                    <div class="file-path">Automate update vulnerable Plugins/Themes:</div>
                    <div><span>No</span><label class="db-fc-switch sl-enable-scheduling-switch">
                      <input class="db-switch__input" type="checkbox" [checked]="autoUpdateProductsFc" (change)="enableAutoUpdate($event)">
                      <div class="db-switch__bg">
                        <div class="db-switch__head"></div>
                      </div>
                    </label><span>Yes</span></div>
                  </div>
                </div>
              </div>
            </form>
          </ng-container>
        </db-tab-content>

        <db-tab-content tabId="scheduling">
          <ng-container *ngIf="activeTab.value === 'scheduling'">
            <form [formGroup]="" class="db-security__scheduling db-security__panel db-panel db-panel_flex db-panel_full-height">
              <div class="db-panel__body">
                <div class="db-scheduling-enable-block">
                  <div class="db-switch-title">{{ 'text_enableScheduling' | dbText }}</div>
                  <label class="db-fc-switch sl-enable-scheduling-switch">
                    <input class="db-switch__input" type="checkbox" [checked]="scheduleEnabled" (change)="enableScheduling($event)">
                    <span class="db-switch__bg">
                        <span class="db-switch__head"></span>
                      </span>
                  </label>
                </div>
                <div class="db-schedule-main-content">
                  <db-schedule (cronExpressionString)="generateScheduleData($event)" [cron_expression]="scheduleSettings?.expression" [title]="'Choose the schedule best suited for your website.'"></db-schedule>


                  <div class="disable-overlay" *ngIf="!scheduleEnabled"></div>
                </div>
                <div class="button-wrap">
                  <a class="db-button db-button_lg db-button_success sl-save-scheduling-params-button" (click)="onSettingsSubmit()"
                     [ngClass]="{'db-button_disabled': securityScheduleLoading}">
                    <span *ngIf="!(securityScheduleLoading$ | async) && !securityScheduleLoading">Save</span>
                    <db-loading-circular-spinner class="sl-save-scheduling-params-progress" *ngIf="(securityScheduleLoading$ | async) || securityScheduleLoading"></db-loading-circular-spinner>
                  </a>
                </div>
              </div>
            </form>
          </ng-container>
        </db-tab-content>
      </db-tabs>
      <db-loading-screen *ngIf="(securityScanRunning$ | async)"></db-loading-screen>
    </div>

    <div class="db-security__info-panel db-panel">
      <div class="db-panel__body">
        <div><img class="db-no-item-image" src="assets/images/icons/security_white_bg.svg" alt=""/></div>

        <div class="db-security__info-content">
          <div><strong>{{(securityIssuesLength$ | async)}}</strong><span> {{(securityIssuesLength$ | async) === 1 ? 'issue' : 'issues'}}</span></div>
          <div><strong>{{(securityVulnerabilitiesLength$ | async)}}</strong><span> {{(securityVulnerabilitiesLength$ | async) === 1 ? 'vulnerability' : 'vulnerabilities'}}</span></div>
        </div>

        <div>
          <a class="db-button db-button_info sl-run-scan-button" [ngClass]="{'db-button_disabled': (securityScanRunning$ | async)}" (click)="runScan()">
            <span>Run Scan</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="db-security__no-items-message db-no-items-message" *ngIf="securityPlugin && (!securityPlugin.paidVersionInstalled || !securityPlugin.active)">
    <div class="db-no-item-image-wrap">
      <img class="db-no-item-image" src="assets/images/icons/security_white_bg.svg" alt=""/>
    </div>
    <div class="db-no-item-title"><span>Hi!</span></div>
    <div class="db-no-item-desc" *ngIf="website?.canActivateServices"><span [innerHtml]="'text_noSecurity' | dbText"></span></div>
    <div class="db-no-item-desc" *ngIf="!website.canActivateServices"><span [innerHtml]="'text_serviceCantActivatePhpVersion' | dbText"></span></div>
    <div *ngIf="website?.canActivateServices">
      <a class="db-button db-button_info db-button_lg sl-enable-security-button" [ngClass]="{'db-button_disabled': !isManagable || (ongoingActivity$ | async)}" (click)="installAndActivate()" *ngIf="!securityPlugin.paidVersionInstalled">
        <span *ngIf="!(ongoingActivity$ | async)">{{'text_enableNow' | dbText}}</span>
        <db-loading-circular-spinner class="sl-enable-security-progress" *ngIf="(ongoingActivity$ | async)"></db-loading-circular-spinner>
      </a>

      <a class="db-button db-button_info db-button_lg" [ngClass]="{'db-button_disabled': !isManagable || (ongoingActivity$ | async)}" (click)="activate()" *ngIf="securityPlugin.paidVersionInstalled && !securityPlugin.active">
        <span *ngIf="!(ongoingActivity$ | async)">{{'text_enableNow' | dbText}}</span>
        <db-loading-circular-spinner class="sl-save-settings-progress" *ngIf="(ongoingActivity$ | async)"></db-loading-circular-spinner>
      </a>
    </div>
    <div class="db-plugin-install-notiff" [innerHTML]="'text_pluginInstallNotiff' | dbText: {pluginName: ' Security'}"></div>

  </div>
  <db-loading-screen class="sl-enable-seo-progress" [ngClass]="{'hidden':!loading || !(ongoingActivity$ | async)}" [pageBlocker]="true"></db-loading-screen>
  <db-how-to-videos [url]="'https://www.youtube.com/embed/YE2c51soJW4?autoplay=1'"></db-how-to-videos>

</div>
